import { pathOr } from 'ramda';

import {
  Box,
  Flex,
  HStack,
  Text,
  UserGroupBadge,
  VStack,
} from '@frontend/components';

import { useUserGroupBadgeLookup } from 'utils/multisite';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';

const QuoteItemPartMatchCell = ({
  quoteItemResult,
}: {
  quoteItemResult: { data: Record<string, any>; highlight: any };
}) => {
  const getBadgeProps = useUserGroupBadgeLookup();
  const badgeProps = getBadgeProps(quoteItemResult.data.ownerId);

  return (
    <Box alignContent="left">
      <Flex
        justifyContent="space-between"
        alignItems="center"
        paddingBottom={0.5}
        minWidth={0}
        width="100%"
      >
        <Flex alignItems="center" flexShrink={0}>
          <Text fontFamily="data" fontSize="sm">
            From{' '}
            <Text as="span" fontSize="sm" fontWeight="heavy">{` Quote #`}</Text>
            <HighlightOrDisplay
              field="quoteNumber"
              result={quoteItemResult}
              textProps={{ fontWeight: 'heavy' }}
              useDataFont
            />
          </Text>
        </Flex>
        {badgeProps && (
          <Box
            flex={1}
            minWidth={0}
            marginLeft={1}
            display="flex"
            justifyContent="flex-end"
            overflow="hidden"
          >
            <UserGroupBadge
              maxWidth="100%"
              size="sm"
              name={badgeProps.name}
              colorPalette={badgeProps.colorPalette}
              icon={badgeProps.icon}
            />
          </Box>
        )}
      </Flex>
      <PartCell
        href={`/quotes/edit/${quoteItemResult.data.quoteNumber}?quote_item=${quoteItemResult.data.id}`}
        partResult={quoteItemResult}
        resultOwnerId={quoteItemResult.data.ownerId}
        filename={pathOr(null, ['data', 'filenames', 0], quoteItemResult)}
        primaryFileUuid={pathOr(
          null,
          ['data', 'primaryFileUuid'],
          quoteItemResult,
        )}
      />
      <HStack paddingTop={1}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Process</LabelText>
          <LabelText>Material</LabelText>
          <LabelText>Finish</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay field="process" result={quoteItemResult} />
          <HighlightOrDisplay field="material" result={quoteItemResult} />
          <HighlightOrDisplay field="finishes" result={quoteItemResult} />
        </VStack>
      </HStack>
    </Box>
  );
};

export default QuoteItemPartMatchCell;
